var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-list',{attrs:{"endpoint":"tipo-requerimento","rota-base":"/admin/tipo-requerimento","titulo":"TIPOS DE REQUERIMENTO","titulo-singular":"Tipo de Requerimento","colunas-extras":[]}})
}
var staticRenderFns = []

export { render, staticRenderFns }